import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2127a834")

_pushScopeId("data-v-2127a834")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "Mithilfe des OntoExplorers kann man einen Einblick in SPARQL-Endpunkte des Semantic Web erhalten. Das beinhaltet das Explorieren durch, das Recherchieren nach und das Filtern von RDF-Datensätzen in diesen Endpunkten.", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("table", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "public")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("b", null, "Führt zur Projekt-Webseite.")
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", null, "Wissensbasis", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "In dieser Komponente können die gewünschten SPARQL-Endpunkte, in denen recherchiert werden soll, ausgewählt werden. Es gibt aber auch weitere Funktionen:", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("table", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "edit")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("b", null, "Bearbeiten eines Endpunktes.")
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td"),
    /*#__PURE__*/_createVNode("td", null, "Es können Änderungen am Kurznamen oder der URL eines Endpunktes vorgenommen werden.")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "delete")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("b", null, "Löschen eines Endpunktes.")
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "add")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("b", null, "Hinzufügen eines Endpunktes.")
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td"),
    /*#__PURE__*/_createVNode("td", null, "Es muss mindestens die URL eines Endpunktes angegeben werden - alternativ auch noch ein Kurzname, um einen besseren Überblick in der Wissensbasis-Liste zu erhalten. Der OntoExplorer prüft, ob die angegebene URL zu einem gültigen Endpunkt führt und ob dieser eventuell schon in der Liste vorhanden ist. ")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "share")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("b", null, "Exportieren der Endpunkte.")
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td"),
    /*#__PURE__*/_createVNode("td", null, "Die genutzten Endpunkte werden im JSON-Format angezeigt. Eine Checkliste ermöglicht es nur bestimmte Endpunkte für den Export auszuwählen. Nach der Auswahl kann die Anzeige kopiert und anderweitig genutzt werden. ")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "file_upload")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("b", null, "Importieren von Endpunkten.")
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td"),
    /*#__PURE__*/_createVNode("td", null, "Um Endpunkte im JSON-Format einzufügen, kann der Text (auch unformatiert) in diese Anzeige kopiert werden. Es ist auch möglich, ihn in diesem Feld noch zu formatieren. Sollten Fehler oder Warnungen für bestimmte Endpunkte beim Einzufügen bestehen, wird im folgenden Fenster darauf hingewiesen. ")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("h3", null, "Klassenhierarchie", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Wenn ein oder mehrere Endpunkte ausgewählt wurden, werden in dieser Komponente alle darin befindlichen Klassen angezeigt. Hinter den Klassen wird die Anzahl der darin befindlichen Instanzen in Klammern angezeigt. Ein Klick auf den Namen füllt dann die "),
  /*#__PURE__*/_createVNode("b", null, "Liste der Elemente"),
  /*#__PURE__*/_createTextVNode(" mit diesen Instanzen.")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("table", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "chevron_right")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("b", null, "Klasse enthält Unterklassen.")
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td"),
    /*#__PURE__*/_createVNode("td", null, "Ein Klick auf den Namen zeigt die Instanzen der Oberklasse an, ein Klick auf den Pfeil klappt die Unterklassen aus, in denen dann ebenso recherchiert werden kann. ")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("h3", null, "Liste der Elemente", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("p", null, "Hier werden alle Instanzen aus der ausgewählten Klasse des Endpunktes angezeigt. Im Fußbereich der Komponente befindet sich die Anzahl der angezeigten Elemente und ein Drop-Down-Menü um die Trefferanzahl auf einer Seite einzustellen.", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("table", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "share")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("b", null, "Teilen der momentanen Ansicht.")
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td"),
    /*#__PURE__*/_createVNode("td", null, "Es wird eine URL generiert, um die momentane Ansicht des OntoExplorers zu teilen. Voraussetzung ist, dass die gleichen Endpunkte auf beiden Seiten vorhanden sind. ")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Beim Klick auf eine Instanz in der Liste ändert sich diese Komponente zu "),
  /*#__PURE__*/_createVNode("b", null, [
    /*#__PURE__*/_createTextVNode("Eigenschaften von "),
    /*#__PURE__*/_createVNode("i", null, "Instanzname")
  ]),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("h3", null, "Attribute", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", null, "Mithilfe der Attributauswahl kann die Liste der Instanzen einer Klasse gefiltert werden, ohne jedes Element einzeln aufzurufen. Beim Auswählen eines Attributs ändert sich sofort die Listenansicht der Elemente und fügt dieses in einer neuen Spalte hinzu. Elemente, die dieses Attribut nicht besitzen haben in dieser Spalte eine Zeile mit \"-\".", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Eigenschaften von "),
  /*#__PURE__*/_createVNode("i", null, "Instanzname")
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", null, "Alle Attribute einer angeklickten Instanz werden hier tabellenartig aufgelistet. Befinden sich Symbole vor Daten in dieser Tabelle heißt das, dass mehr Informationen vorliegen. Mit klickbaren Links gelangt man auf die Eigenschaften-Seite der jeweiligen Instanz.", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("table", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "link")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("b", null, "Öffnen der Original-Ressource in einem neuen Tab.")
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "chevron_right")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("b", null, "Öffnen einer Untertabelle mit den Eigenschaften der jeweiligen Instanz.")
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GenericDialog = _resolveComponent("GenericDialog")

  return (_openBlock(), _createBlock(_component_GenericDialog, {
    header_text: "Hilfestellung",
    max_width: "65rem",
    max_height: "65vh",
    onClose: _ctx.onCancel
  }, {
    default: _withId(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      _hoisted_16,
      _hoisted_17
    ]),
    _: 1
  }, 8, ["onClose"]))
})